enum CustomFeature {
    USE_STATIC_STORES = 'useStaticStores',
    RETURN_PARCEL_TO_REQUESTER = 'returnParcelToRequester'
}

export { CustomFeature };
